import React from "react";

function ExpandableSection({ title, defaultOpen = false, children, className = "" }) {
  const classes = ["ui-expandable", className].filter(Boolean).join(" ");

  return (
    <details className={classes} open={defaultOpen}>
      <summary className="ui-expandable__summary">{title}</summary>
      <div className="ui-expandable__body">{children}</div>
    </details>
  );
}

export default ExpandableSection;
